var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-nav-link",class:{
    active: _vm.active,
    alert: _vm.alert
  },on:{"click":function($event){return _vm.$emit('navigate')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }